<template>
  <nav
    v-if="count > 1"
    class="sm:hidden grid bg-primary/70 backdrop-blur shadow-lg px-4 min-h-16 py-3 pt-3 text-action z-20 w-full fixed bottom-0"
    :class="[
      `grid-cols-${count}`,
      isApp ? 'pb-8 h-22' : 'pb-3 h-16'
    ]"
  >
    <template v-if="customMenu">
      <template v-for="item in customMenu">
        <template v-if="item.type === 'group' && item.children && item.children.length">
          <LayoutElementsMobileGroup :item="item" />
        </template>

        <template v-else-if="item.type === 'tab' || item.type === 'custom'">
          <LayoutElementsMobileItem :item="item" :key="`${item.id}-${item.type}`" />
        </template>
      </template>
    </template>

    <!-- Has Default (Auto) Menu -->
    <template v-else>
      <template v-for="tab in enabledTabs">
        <LayoutElementsMobileItem
          v-if="$site.tabs.book"
          :key="tab"
          :item="{ id: tab, name: $site.tabs.getName(tab, tab) }"
        />
      </template>
    </template>
  </nav>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()
const layoutStore = useLayoutStore()

const tabs = [
  'book',
  'timetable',
  'lastMinute',
  'giftCard',
  'pass',
  'gallery',
  'review'
]

const customMenu = computed(() => {
  if ($site.menu?.primary) {
    return $site.menu?.primary || []
  }

  return false
})

const enabledTabs = computed(() => {
  const _tabs = tabs.filter(tab => $site.tabs[tab])

  _tabs.length = Math.min(_tabs.length, 5)

  return _tabs
})

const layout = computed(() => {
  return layoutStore.layout
})

const isApp = computed(() => {
  return layout.value === 'app'
})



const count = computed(() => {
  if (customMenu.value) {
    return customMenu.value.length
  }

  return enabledTabs.value.length
})
</script>
